<template>
  <CustomUpdateDialog
    dialogTitle="ویرایش نقش"
    dialogId="update-role-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendUpdateUserTypeRequest"
  >
    <template v-if="defaultUserType && tempUserType">
      <BCol cols="12">
        <TextInput
          v-model="tempUserType.name"
          :formatter="filterOnlyEnglishAlphabet"
          inputId="name"
          inputLabel="نام انگلیسی نقش"
          inputPlaceholder="Accountant"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <TextInput
          v-model="tempUserType.title"
          inputId="title"
          inputLabel="نام فارسی نقش"
          inputPlaceholder="حسابدار"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <TextInput
          v-model="tempUserType.description"
          inputId="description"
          inputLabel="توضیحات نقش"
          inputPlaceholder="توضیحات..."
        ></TextInput>
      </BCol>
    </template>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    defaultUserType: {
      type: Object,
    },
  },
  watch: {
    defaultUserType: {
      handler(val) {
        if (val) {
          this.tempUserType = JSON.parse(JSON.stringify(this.defaultUserType));
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      tempUserType: null,
      englishRegex: /^[A-Za-z\s]+$/,
      isOkButtonDisabled: false,
    };
  },
  methods: {
    filterOnlyEnglishAlphabet(value) {
      if (this.englishRegex.test(value)) {
        return value;
      }
    },
    async sendUpdateUserTypeRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let updateAUserType = new UpdateAUserType(_this);
        updateAUserType.setRequestParamDataObj(_this.tempUserType);
        await updateAUserType.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "EditIcon",
                variant: "success",
                text: "نقش با موفقیت ویرایش شد!",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide("update-role-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
    TextInput,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { UpdateAUserType } from "@/libs/Api/UserType";
</script>
